import {getAppConfig} from "./auth/GetAppConfig";
import {ProjectInformation} from "./state-slices/state-management/definitions/ProjectInformation";

export function getFullUrlFromRelative(path: string, currentProject: ProjectInformation) {
    const pathWithoutPrecedingSlash = path[0] === '/' ? path.substring(1) : path;
    const config = getAppConfig();
    return `${config.mediaBucketUrl}/${currentProject?.s3Key}${pathWithoutPrecedingSlash}`
}
